<template>
  <div :class="['tag-wrapper', inputClass]" :style="{backgroundColor: hexToRgbA(color, 0.15)}">
    <span :class="['tag-name']" :style="{color: color}">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'TagColor',
  props: {
    color: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'TAG NAME',
    },
    inputClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    hexToRgbA(hex, opacity = 1) {
      let c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = `0x${c.join('')}`;
        // eslint-disable-next-line no-bitwise
        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`;
      }
      throw new Error('Bad Hex');
    },
  },
};
</script>

<style scoped>
.tag-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 5px;
  border-radius: 3px;
  text-align: center;
}

.tag-name {
  width: 100%;
  font-size: 11px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 2px 5px;
  border-radius: 3px;
  display: inline-block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Tags/TagColor.vue